import React, { useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';

const SignatureField = ({
    fieldName, // e.g., "responsiblePersonSignature"
    label = "", // Optional label override
    formData,
    isEditing,
    isDisabled,
    signatures,
    canvasRefs,
    invalidFields,
    updateSignatureData,
    clearSignature,
    toggleEditMode,
    isNext
}) => {
    const localRef = canvasRefs[fieldName];

    useEffect(() => {
        const canvasEl = localRef?.current?.getCanvas?.();
        if (!canvasEl) return;

        // Prevent touch gestures from scrolling or zooming the page
        const preventTouch = (e) => e.preventDefault();

        canvasEl.addEventListener("touchstart", preventTouch, { passive: false });
        canvasEl.addEventListener("touchmove", preventTouch, { passive: false });

        return () => {
            canvasEl.removeEventListener("touchstart", preventTouch);
            canvasEl.removeEventListener("touchmove", preventTouch);
        };
    }, [localRef]);


    const hasError =
        invalidFields.includes(label) && !formData[fieldName];

    return (
        <div className="mb-4">
            {formData[fieldName] && !isEditing[fieldName] ? (
                <>
                    <label className="block text-base font-medium text-black mb-3">
                        {label}
                    </label>
                    <img
                        src={signatures[fieldName]}
                        alt="Signature"
                        loading="eager"
                        style={{
                            width: '300px',
                            height: '100px',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            borderRadius: '0.375rem', // same as Tailwind's rounded-md
                            border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                            objectFit: 'contain',
                            display: 'block',
                        }} 
                        />
                </>
            ) : (
                <>
                    <label className="block text-base font-medium text-black mb-3">
                        {label}
                    </label>
                    <SignatureCanvas
                        ref={localRef}
                        backgroundColor="white"
                        penColor="black"
                        canvasProps={{
                            width: 500,
                            height: 128,
                            className: `rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${hasError ? 'border border-red-500' : 'border border-gray-300'
                                }`,
                        }}
                        disabled={isDisabled}
                    />
                </>

            )}
            {!isNext && (
                <div className="flex space-x-4 mt-4">
                    {!formData[fieldName] &&
                        <button
                            disabled={isDisabled}
                            type="button"
                            onClick={() => updateSignatureData(fieldName)}
                            className="px-6 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
                        >
                            <i className="fas fa-save mr-2"></i>
                            Save
                        </button>
                    }

                    <button
                        disabled={isDisabled}
                        type="button"
                        onClick={() => {
                            toggleEditMode(fieldName, true);
                            clearSignature(fieldName);
                        }}
                        className="px-6 py-2 bg-red-600 text-white rounded-lg shadow hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
                    >
                        <i className="fas fa-eraser mr-2"></i>
                        Clear
                    </button>
                </div>
            )}

        </div>
    );
};

export default SignatureField;
